<template>
  <AppButton
    v-bind="$attrs"
    :variant="variant"
    :size="size"
    :disabled="disabled"
    :type="type"
    @click="(event: MouseEvent) => emit('click', event)"
  >
    <template #icon-left>
      <slot name="icon-left" />
    </template>
    <slot />
    <template #icon-right>
      <slot name="icon-right" />
    </template>
  </AppButton>
</template>

<script setup lang="ts">
import AppButton from './AppButton.vue'
import {
  ButtonSize,
  ButtonType,
  ButtonVariant,
} from './AppButton.vue'
import type { AppButtonProps } from './AppButton.vue'

export interface BaseButtonProps extends AppButtonProps {}

withDefaults(defineProps<BaseButtonProps>(), {
  variant: ButtonVariant.Primary,
  size: ButtonSize.Md,
  disabled: false,
  type: ButtonType.Button,
})

// Re-emit the click event so existing BaseButton consumers still see `click`.
const emit = defineEmits<{
  (e: 'click', event: MouseEvent): void
}>()
</script>